import { Injectable } from '@angular/core';
import { AuthService } from "@app/common/services/auth.service";

@Injectable({ providedIn: 'root' })
export class ApproveFinalSolutionTypeService {

  constructor(
    private authService: AuthService,
  ) { }

  public canApproveFinalSolutionType(): boolean {
    return  this.authService.hasPermission('approve_final_solution') || this.authService.isManager();
  }
}
